var map = {
	"./ana.webp": 8236,
	"./ashe.webp": 6401,
	"./baptiste.webp": 5160,
	"./bastion.webp": 9638,
	"./brigitte.webp": 9512,
	"./cassidy.webp": 1112,
	"./d.va.webp": 2337,
	"./doomfist.webp": 5581,
	"./echo.webp": 1355,
	"./genji.webp": 4985,
	"./hanzo.webp": 4662,
	"./illari.webp": 4033,
	"./junker-queen.webp": 3232,
	"./junkrat.webp": 651,
	"./juno.webp": 6228,
	"./kiriko.webp": 8605,
	"./lifeweaver.webp": 6391,
	"./lucio.webp": 3966,
	"./mauga.webp": 9815,
	"./mei.webp": 6787,
	"./mercy.webp": 7150,
	"./moira.webp": 8940,
	"./orisa.webp": 4410,
	"./pharah.webp": 6040,
	"./ramattra.webp": 3320,
	"./reaper.webp": 261,
	"./reinhardt.webp": 9215,
	"./roadhog.webp": 7202,
	"./sigma.webp": 9501,
	"./sojourn.webp": 2922,
	"./soldier--76.webp": 6259,
	"./sombra.webp": 5938,
	"./symmetra.webp": 6372,
	"./torbjörn.webp": 3367,
	"./tracer.webp": 2215,
	"./venture.webp": 201,
	"./widowmaker.webp": 4864,
	"./winston.webp": 3557,
	"./wrecking-ball.webp": 7146,
	"./zarya.webp": 6497,
	"./zenyatta.webp": 7644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5332;